import React, { FC, useEffect, useState } from 'react';
import MainHeader from '../../../components/Calendar/Header'
import { useDispatch, useSelector } from '../../../store/index'
import { setHeaderView } from '../../../store/application/slice'
import { HEADER_VIEW } from '../../../store/application/types';
import EditIcon from '../../../components/UI/Icons/Edit'
import TrashIcon from '../../../components/UI/Icons/Trash'
import CustomButton from '../../../components/UI/Buttons/CustomButton'
import { deleteHashtagThunk, getHashtagThunk } from '../../../store/hashtag/thunks';
import { Hashtag } from '../../../store/hashtag/types';
import { setEditHastagAction } from '../../../store/hashtag/slice';
import { toggleHastagModalAction } from '../../../store/application/slice';
import { TOAST_MESSAGE } from '../../../components/UI/ToastNotification/ToastNotification'
import { useToasts } from 'react-toast-notifications';
import './Hashtag.scss'
import { isFulfilled } from '@reduxjs/toolkit';
import ConfirmPopup from '../../../components/UI/ConfirmPopup'



interface NotificationProps { }

const Notification: FC<NotificationProps> = () => {

    const { hashtags, projectId } = useSelector((state) => ({
        hashtags: state.hashtag.hashtags,
        projectId: state.project.currentProject.id
    }))

    const dispatch = useDispatch();
    const { addToast } = useToasts()

    const [ showConfirm, setShowConfirm] = useState(false);
    const [ hashTagdeleteId, setHashTagdeleteId] = useState(0);

    const getHashtags = async () => {
        await dispatch(getHashtagThunk(projectId));
    }

    useEffect(() => {
        dispatch(setHeaderView(HEADER_VIEW.HASHTAG));
        getHashtags();
    }, [projectId])

    const openModal = (data?: Hashtag) => {
        if (data) {
            dispatch(setEditHastagAction(data))
        }
        dispatch(toggleHastagModalAction())
    }

    const onConfirmDelete = async() => {
        const response = await dispatch(deleteHashtagThunk(hashTagdeleteId))
        if (isFulfilled(response)) {
            setShowConfirm(false)
            addToast(TOAST_MESSAGE.HASH_DELETED, { appearance: 'success' })
            getHashtags();
        }
    }

    const deleteHash = (data:Hashtag)=>{
        setHashTagdeleteId(data.id)
        setShowConfirm(true)
    }

    return (
        <div className='hashtag-page-wrapper'>
            <MainHeader />
            <div className="hashtag-wrapper">
                <div className="hashtag-page__wrapper">
                    <div className='hashtag-page__container'>
                        <div className='hashtag-page__header-wrapper'>
                            <div className="hashtag-page__container__header">Hashtag Pool Preferences</div>
                            <div> <CustomButton button='primary' onClick={() => openModal()}> Create New Pool </CustomButton></div>
                        </div>
                        <div className="hashtag-page__container__content">
                        {hashtags.length >0? <table>
                                <thead>
                                    <tr>
                                        <th className="text-left tb-header w-80">Pool Name</th>
                                        <th className='w-20' colSpan={5} ><div className="time-header"><span className="ml-1">TAGS</span> </div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {hashtags.map((v: Hashtag, k: number) => (
                                        <tr>
                                            <td className="text-left" colSpan={3}>{v.pool_name}</td>
                                            <td>{v.tags_count} </td>
                                            <td colSpan={1} className="text-right">
                                                <CustomButton
                                                    className='hashtag-page__btntransparent'
                                                    onClick={() => openModal(v)}
                                                    button='subtle'
                                                    size='big'
                                                >
                                                    <EditIcon />
                                                </CustomButton>
                                                <CustomButton
                                                    className='hashtag-page__btntransparent'
                                                    onClick={() => deleteHash(v)}
                                                    button='subtle'
                                                    size='big'
                                                >
                                                    <TrashIcon />
                                                </CustomButton>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>: <div className='no-hashtag'>There are no pools added yet</div> }
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmPopup
                onConfirm={onConfirmDelete}
                onClose={()=>setShowConfirm(false)}
                isModalOpen={showConfirm}
            >
                Are you sure you want to delete this hashtag?
            </ConfirmPopup>
        </div>

    )
}

export default Notification;